import  breakfast  from "../img/kindfood/breakfast.jpg"
import  mainFood  from "../img/kindfood/mainFood.jpg"
import  appetizer  from "../img/kindfood/appetizer.jpg"
import  deser  from "../img/kindfood/fried.jpg"
import  coldDrink  from "../img/kindfood/colddrink.jpg"
import  kabab  from "../img/kindfood/kabab.jpg"
import  drinks  from "../img/kindfood/drinks.jpg"
import  irani  from "../img/kindfood/irani.jpg"
import  hotDrinkOnCoffee  from "../img/kindfood/hotDrinkOnCoffee.jpg"
import  hotDrink  from "../img/kindfood/hotDrink.jpg"
import  smooti  from "../img/kindfood/smooti.jpg"
import  moktel  from "../img/kindfood/moktel.jpg"
import  teaAndHerbal  from "../img/kindfood/herbalTea.jpg"
import  iceCoffee  from "../img/kindfood/iceCoffee.jpg"
import  cake  from "../img/kindfood/cack.jpg"
import  shake  from "../img/kindfood/shake.jpg"
import  iceCream  from "../img/kindfood/icecream.jpg"
import  hookah  from "../img/kindfood/hookah.jpg"
import iceTea from '../img/kindfood/icetea.jpg'
import fizzy from '../img/kindfood/fizzy.jpg'



export const kindFood=[
    {
        "id" : 0 ,
        "title" : "کباب‌ها(بدون پلو)",
        "idNmae":'kabab',
        "image" : kabab,
    },
    {
        "id" : 1 ,
        "title" : "ایرانی/سنتی",
        "idNmae":'irani',
        "image" : irani,
    },
    {
        "id" : 2 ,
        "title" : "پیش‌غذاها",
        "idNmae":'appetizer',
        "image" : appetizer,
    },
    {
        "id" : 3 ,
        "title" : "‌دسر‌ها",
        "idNmae":'deser',
        "image" : deser,
    },
    {
        "id" : 4 ,
        "title" : "صبحانه",
        "idNmae":'breakfast',
        "image" : breakfast,
    },
    {
        "id" : 5 ,
        "title" : "نوشیدنی‌ها",
        "idNmae":'drink',
        "image" : drinks,
    },
    {
        "id" : 6 ,
        "title" : "نوشیدنی‌های گرم",
        "idNmae":'hotDrink',
        "image" : hotDrink,
    },
    {
        "id" : 7 ,
        "title" : "نوشیدنی‌های سرد",
        "idNmae":'coldDrink',
        "image" : coldDrink,
    },
    {
        "id" : 8 ,
        "title" : "کیک‌ها",
        "idNmae":'cake',
        "image" : cake,
    },
    {
        "id" : 8 ,
        "title" : "بستنی‌ها",
        "idNmae":'iceCream',
        "image" : iceCream,
    },
    
]